module.exports = __webpack_public_path__ + "img/hero.39f3f8d0.jpg";